import { fetcher, queryString, useRecoilQuery } from '@shared/hooks/recoil-query';
import { LowerRole } from '@shared/types';

import {
  giftChoiceUnitDataAtomFamily,
  giftChoiceUnitListDataAtom,
  giftChoiceUnitListStatusAtom,
  giftChoiceUnitStatusAtomFamily,
} from './giftChoiceUnit.atom';

const giftChoiceUnitPopulate = {
  populate: ['image', 'giftItemBrand'],
};

// GiftChoiceUnit 목록 조회
const giftChoiceUnitListUrl = (role: LowerRole) => {
  return `/${role}/gift-choice-unit?${queryString({
    ...giftChoiceUnitPopulate,
    options: { sort: { name: 1 } },
  })}`;
};

export const useGiftChoiceUnitListHook = (role: LowerRole, skip = false) => {
  useRecoilQuery(
    giftChoiceUnitListStatusAtom,
    giftChoiceUnitListDataAtom,
    giftChoiceUnitListUrl(role),
    fetcher,
    skip,
  );
};

// GiftChoiceUnit 단건 조회
const giftChoiceUnitUrl = (id: string, role: LowerRole) => {
  return `/${role}/gift-choice-unit/${id}?${queryString(giftChoiceUnitPopulate)}`;
};

export const useGiftChoiceUnitHook = (id: string, role: LowerRole, skip = false) => {
  useRecoilQuery(
    giftChoiceUnitStatusAtomFamily(id),
    giftChoiceUnitDataAtomFamily(id),
    giftChoiceUnitUrl(id, role),
    fetcher,
    skip || !id,
  );
};
